import Header from '../../Header'

import Lottie from 'react-lottie'
import * as animationData from '../../../assets/95088-success.json'
import { Button, Row } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Loading from '../../Loading'
import { IconChevronLeft } from '@tabler/icons-react'

const SuccessApplications = () => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <>
      {!state ? (
        <Loading />
      ) : (
        <>
          <Header backButton={false} />
          <div style={{ with: '100%' }}>
            <Lottie options={defaultOptions} height={175} width={200} />

            <Row
              style={{
                display: 'flex',
                textAlign: 'center',
                color: '#285843',
              }}
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 25,
                }}
              >
                Başvuru Tamamlandı
              </p>
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyItems: 'center',
                textAlign: 'center',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                color: '#285843',
              }}
            >
              <p>
                <b>{`#${state?.id}`}</b> numaralı başvurunuz başarıyla gerçekleştirilmiştir.
              </p>
            </Row>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#285843',
              marginTop: '1rem',
            }}
          >
            <Button
              block
              style={{
                marginRight: '1rem',
                marginLeft: '1rem',
                backgroundColor: '#285843',
                borderRadius: '5px',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              }}
              onClick={() => navigate('/')}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <IconChevronLeft
                  style={{
                    backgroundColor: 'inherit',
                    alignItems: 'center',
                    color: '#fff',
                    marginRight: '1rem',
                  }}
                  size={20}
                />
                <div style={{ paddingBottom: 4 }}>Başvuru Listesine Dön</div>
              </div>
            </Button>
          </div>
        </>
      )}
    </>
  )
}

export default SuccessApplications
